/**
 * Centralized mapping for custom instrument display names.
 * This overrides the auto-generated or stored names for specific instruments.
 * Use this when customers need specific labeling that differs from the technical names.
 */
export const INSTRUMENT_DISPLAY_NAME_OVERRIDES: Record<string, string> = {
  // Cytomats - custom labels for customer clarity
  cytomat10_1: 'Cytomat - Hotel',
  cytomatC425_1: 'Cytomat - Cold Incubator',
  cytomatC450_1: 'Cytomat - Warm Incubator',
};

/**
 * Get the display name for an instrument, checking overrides first.
 * @param instrumentId - The instrument ID
 * @param fallbackName - The name to use if no override exists
 * @returns The display name to show in the UI
 */
export const getInstrumentDisplayName = (
  instrumentId: string,
  fallbackName: string
): string => {
  return INSTRUMENT_DISPLAY_NAME_OVERRIDES[instrumentId] ?? fallbackName;
};
